import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface ModifierCerclePictoProps extends pictoProps {
}

export interface ModifierCerclePictoState extends pictoState {
}

export class ModifierCerclePicto extends Picto<ModifierCerclePictoProps,ModifierCerclePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.modifierCerclePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(ModifierCerclePicto);
